import { render } from "./Welcome.vue?vue&type=template&id=2b410857&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=2b410857&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b410857"

export default script